<template>

</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'sysEnterpriseExt',
    data() {
      return {}
    },
    created() {

    },
    computed: {
      ...mapGetters([
        'elements'
      ])
    },
    methods: {

    }
  }
</script>
